<template>
  <div class="d-flex flex-column">
    <div id="header" class="mb-2">
      <slot name="header"></slot>
    </div>
    <div id="content" class="mb-2" style="flex: 1">
      <slot></slot>
    </div>
    <div id="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabContentLayout'
}
</script>
